import { createSlice } from "@reduxjs/toolkit";
import {
    fetchQuestionOptionsTableColumnNames,
    fetchAllQuestionOptions,
    createQuestionOptions,
    updateQuestionOptions,
    deleteQuestionOptions
} from "./thunk";
import { toast } from "react-toastify";

const questionOptionsSlice = createSlice({
  name: "QuestionOptions",
  initialState: {
    questionOptions: [],
    tableColumnNames: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder

      // Fetch Referral Reward Table Column Names
      .addCase(fetchQuestionOptionsTableColumnNames.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuestionOptionsTableColumnNames.fulfilled, (state, action) => {
        state.loading = false;
        state.tableColumnNames = action.payload;
      })
      .addCase(fetchQuestionOptionsTableColumnNames.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Get All Referral Reward
      .addCase(fetchAllQuestionOptions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAllQuestionOptions.fulfilled, (state, action) => {
        state.loading = false;
        state.questionOptions = action.payload;
      })
      .addCase(fetchAllQuestionOptions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Referral Reward
      .addCase(createQuestionOptions.pending, (state) => {
        state.error = null;
      })
      .addCase(createQuestionOptions.fulfilled, (state, action) => {
        state.questionOptions = [action.payload.data[0], ...state.questionOptions];
        toast.success(action.payload.message);
      })
      .addCase(createQuestionOptions.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Update Referral Reward
      .addCase(updateQuestionOptions.pending, (state) => {
        state.error = null;
      })
      .addCase(updateQuestionOptions.fulfilled, (state, action) => {
        const index = state.questionOptions.findIndex(
          (item) => item.ID === action.payload[0].ID
        );

        if (index !== -1) {
          state.questionOptions[index] = action.payload[0];
        }

        toast.success("Updated successfully");
      })
      .addCase(updateQuestionOptions.rejected, (state, action) => {
        state.error = action.payload;
      })

      // Delete Referral Reward
      .addCase(deleteQuestionOptions.pending, (state) => {
        state.error = null;
      })
      .addCase(deleteQuestionOptions.fulfilled, (state, action) => {
        const deletedIds = action.payload.map((item) => item.ID);

        // Filter out the deleted items
        state.questionOptions = state.questionOptions.filter(
          (item) => !deletedIds.includes(item.ID)
        );

        toast.success("Deleted successfully");
      })
      .addCase(deleteQuestionOptions.rejected, (state, action) => {
        state.error = action.payload;
      })
    },
});

export default questionOptionsSlice.reducer;